import useApi from "@/hooks/useApi.ts";

import {
  SupportTemplate,
  Support,
  CompletedSupport,
  SupportUpdateUp,
  SupportContentUp,
} from "@/types/Support";

type UseSupportApiHook = {
  token?: string;
  getSupportTemplates: () => Promise<SupportTemplate[]>;
  getSupports: () => Promise<Support[]>;
  getSupportStatus: () => Promise<CompletedSupport[]>;
  updateSupport: <T extends SupportContentUp>(
    params: SupportUpdateUp<T>
  ) => Promise<void>;
  syncSupports: () => Promise<void>;
};
const useSupportApi = (): UseSupportApiHook => {
  const { token, apiGet, apiPut } = useApi(); // only for testing

  const getSupportTemplates = (): Promise<SupportTemplate[]> => {
    return apiGet<SupportTemplate[]>(`/supports/template`);
  };

  const getSupports = (): Promise<Support[]> => {
    return apiGet<Support[]>(`/supports`);
  };

  const syncSupports = (): Promise<void> => {
    return apiGet<void>(`/supports/sync`);
  };

  const getSupportStatus = (): Promise<CompletedSupport[]> => {
    return apiGet<CompletedSupport[]>(`/supports/completed`);
  };

  const updateSupport = <T extends SupportContentUp>({
    id,
    content,
  }: SupportUpdateUp<T>): Promise<void> => {
    return apiPut<SupportUpdateUp<T>, void>(`/supports/${id}`, { id, content });
  };

  return {
    token,
    getSupports,
    getSupportStatus,
    syncSupports,
    getSupportTemplates,
    updateSupport,
  };
};

export default useSupportApi;
